import React, { useState } from 'react';

function FullScreenStepper({ steps, onFinish, customOnFinish, onExit, onContinueFunc, exitButtonType = 'x' }) {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  // Navigation functions
  const onContinue = async () => {
    onContinueFunc && onContinueFunc();
    
    if (currentStepIndex < steps.length - 1) {
      setCurrentStepIndex(currentStepIndex + 1);
    } else {
      if (customOnFinish) {
        customOnFinish();
      } else {
        onFinish();
      }
    }
  };

  const onBack = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex(currentStepIndex - 1);
    }
  };

  const currentStep = steps[currentStepIndex];

  return (
    <>
      {currentStep && React.cloneElement(currentStep, {
        onContinue,
        onBack,
        onExit,
        exitButtonType,
        isFirstStep: currentStepIndex === 0,
        onFinish: customOnFinish || onFinish,
      })}
    </>
  );
}

export default FullScreenStepper;
